<script>
    import { PolarArea } from 'vue-chartjs'

    export default {
        name: 'polar-graph',
        extends: PolarArea,
        props: {
            chartData: Object,
            legendId: String
        },
        watch: {
            chartData () {
                this.renderChart(this.chartData, this.options)
                document.getElementById(this.legendId).innerHTML = this.generateLegend()
            }
        },
        mounted () {
            this.renderChart(this.chartData, this.options)
            document.getElementById(this.legendId).innerHTML = this.generateLegend()
        },
        methods: {
            onClickHandle (point, event) {
                const item = event[0]
                this.$emit('on-click-in-graph-element',
                           item._model.label
                )
            }
        },
        data () {
            return {
                htmlLegend: null,
                options: {
                    responsive: true,
                    onClick: this.onClickHandle,
                    legend: {
                        display: false,
                        labels: {
                            lineWidth: 62,
                            boxWidth: 15,
                            fontSize: 11
                        }
                    },
                    tooltips: {
                        titleFontSize: 11,
                        bodyFontSize: 11

                    },
                    legendCallback: chart => {
                        let html = '<ul>'
                        chart.data.labels.forEach((l, i) => {
                            const ds = chart.data.datasets[0]
                            const bgColor = ds.backgroundColor[i]
                            const completionAmount = ds.data[i]

                            html += `<li style="padding: 5px;">
                                      <span style="width: 36px; height: 14px; padding: 0 10px 0 15px; margin-right: 7px; background-color:${bgColor};">&nbsp;</span>
                                      <span id="legend-label">${(i + 1)}. ${l}</span>
                                      <span style="font-family: Nunito-Bold, sans-serif;" id="legend-amount"> - ${completionAmount}</span>
                                      </li>`
                        })
                        return html + '</ul>'
                    }
                }
            }
        }
    }
</script>
